import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from "../assets/locales/en/translation.json";
import translationFR from "../assets/locales/fr/translation.json";
import translationIT from "../assets/locales/it/translation.json";
import translationES from "../assets/locales/es/translation.json";
import translationDE from "../assets/locales/de/translation.json";
import translationNL from "../assets/locales/nl/translation.json";
import translationPT from "../assets/locales/pt/translation.json";
import translationCY from "../assets/locales/cy/translation.json";

const resources = {
	en: {
		translation: translationEN
	},
	fr: {
		translation: translationFR
	},
	it: {
		translation: translationIT
	},
	es: {
		translation: translationES
	},
	de: {
		translation: translationDE
	},
	nl: {
		translation: translationNL
	},
	pt: {
		translation: translationPT
	},
	cy: {
		translation: translationCY
	}
};

i18n
	.use(initReactI18next)
	.init({
		resources,
		fallbackLng: 'en',
		debug: false,
		interpolation: {
			escapeValue: false
		},
		react: {
			useSuspense: false
		},
		defaultNS: 'translation'
	});


export default i18n;
